import { ApiResponse, IRequestOptions, IRequestConfig, getConfigs, axios, basePath } from "./index.defs";

export class UserService {
    /**
     *
     */

    /** data is a "phone authorized already" flag */
    static sendCode(
        params: {
            /**  */
            phone?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<{ success: boolean; error?: string; data?: boolean }> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/user/sendCode";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { phone: params["phone"] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static checkCode(
        params: {
            /**  */
            phone?: string;
            /**  */
            code?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/user/checkCode";

            const configs: IRequestConfig = getConfigs("get", "application/json", url, options);
            configs.params = { phone: params["phone"], code: params["code"] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    static checkStatus(
        params: {
            /**  */
            phone?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<{ success: boolean; error?: string }> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/user/checkStatus";

            const configs: IRequestConfig = getConfigs("get", "application/json", url, options);
            configs.params = { phone: params["phone"], code: params["code"] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}
